import clsx from 'clsx';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { ButtonWithPopover } from './ButtonWithPopover.molecule';
import type { ButtonVariant } from '@seeqdev/qomponents';
import { Button } from '@seeqdev/qomponents';

export type ButtonWithPopoverAttachedProps = {
  id: string;
  onClick: () => void;
  label: string;
  popoverContent: React.ReactNode;
  showPopover?: boolean;
  popoverIndicator?: React.ReactNode;
  testId?: string;
  disabled?: boolean;
  variant?: ButtonVariant;
  icon?: string;
  iconPrefix?: string;
};

/**
 * A normal button with a popover button (`<ButtonWithPopover />`) attached
 */
export const ButtonWithPopoverAttached: React.FunctionComponent<ButtonWithPopoverAttachedProps> = ({
  id,
  label,
  onClick,
  showPopover = true,
  popoverIndicator = undefined,
  popoverContent,
  testId = 'buttonWithPopoverAttached',
  disabled,
  variant = 'theme',
  icon,
  iconPrefix,
}) => {
  const { t } = useTranslation();

  return (
    <div className="ml5 tw:inline-flex tw:items-center tw:justify-center" data-testid={testId}>
      <Button
        label={t(label)}
        extraClassNames={clsx('height-30', {
          noRightRadius: showPopover && popoverContent,
        })}
        onClick={onClick}
        testId={`${testId}Button`}
        disabled={disabled}
        variant={variant}
        icon={icon}
        iconPrefix={iconPrefix}
      />
      {showPopover && popoverContent && (
        <ButtonWithPopover
          popoverConfig={{ id: `${id}Popover`, placement: 'bottom' }}
          label={
            <Button
              variant={variant}
              stopPropagation={false}
              extraClassNames="height-30 mln1 noLeftRadius"
              icon={_.isUndefined(popoverIndicator) ? 'fa-caret-down' : undefined}
              iconStyle="white"
              label={popoverIndicator}
              testId={`${testId}PopoverLabel`}
            />
          }>
          {popoverContent}
        </ButtonWithPopover>
      )}
    </div>
  );
};
